<template>
  <v-card
    outlined
  >
    <v-card-title>

      <div class="title black--text text-uppercase">
        Programari
      </div>

    </v-card-title>
    <v-card-subtitle>
      <div class="subtitle-6 black--text">
        <v-btn
          x-small
          color="secondary"
          dark
          @click="geta()">Ultimele 7 zile</v-btn> <v-btn
            x-small
            color="secondary"
            dark
            @click="getb()">Ultimele 30 zile</v-btn>
      </div>
    </v-card-subtitle>
    <v-card-text>
      <LineChart
        :chart-data="datacollection"
        :options="options"
        style="height:200px;"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'moment/locale/ro'
import LineChart from '../chart/LineChart.js'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
export default {
  name: 'ProgramariChart',
  components: { LineChart, ChartJsPluginDataLabels },
  data () {
    return {
      useruid: localStorage.getItem('useruid'),
      datacollection: null,

      options: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              stepSize: 5,
              fontColor: '#999999'
            },
            gridLines: {
              borderDash: [2, 2],
              color: '#999999'
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: '#999999'
            },
            type: 'time',
            time:
                    {
                      unit: 'day',
                      displayFormats: { month: 'MMM YYYY' },
                      max: new moment(),
                      min: new moment().add(-30, 'days')
                    },
            gridLines: {
              borderDash: [2, 2],
              color: '#99999'
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    programari () {
      var identificator = this.useruid
      return this.$store.state.Programari.programari.filter(function (e) {
        return e.idMedic == identificator
      })
    },
    programariDataInterval () {
      var data = [...new Array(30)].map((i, idx) => moment().startOf('day').subtract(idx, 'days').format('YYYY-MM-D'))

      for (var i = 0; i < this.programari.length; i++) {
        var minDate = moment().subtract(30, 'days').format()
        var maxDate = moment().subtract(0, 'days').format()
        var curentDate = moment(this.programari[i].startProgramare).format()
        if (moment(curentDate).isBetween(minDate, maxDate)) {
          // data.push({x: moment(this.programari[i].startProgramare).format('YYYY-MM-D'), y: 1})
          data.push(moment(this.programari[i].startProgramare).format('YYYY-MM-D'))
        }
      }

      return data.slice().sort((a, b) => new moment(a).format('YYYYMMDD') - new moment(b).format('YYYYMMDD'))
    },
    programariDataIntervalSeven () {
      var data = [...new Array(7)].map((i, idx) => moment().startOf('day').subtract(idx, 'days').format('YYYY-MM-D'))

      for (var i = 0; i < this.programari.length; i++) {
        var minDate = moment().subtract(7, 'days').format()
        var maxDate = moment().subtract(0, 'days').format()
        var curentDate = moment(this.programari[i].startProgramare).format()
        if (moment(curentDate).isBetween(minDate, maxDate)) {
          // data.push({x: moment(this.programari[i].startProgramare).format('YYYY-MM-D'), y: 1})
          data.push(moment(this.programari[i].startProgramare).format('YYYY-MM-D'))
        }
      }

      return data.slice().sort((a, b) => new moment(a).format('YYYYMMDD') - new moment(b).format('YYYYMMDD'))
    },
    programariDataSortat () {
      var data = []
      var dataNr = []
      var prev
      for (var i = 0; i < this.programariDataInterval.length; i++) {
        if (this.programariDataInterval[i] !== prev) {
          data.push(this.programariDataInterval[i])
          dataNr.push(1)
        } else {
          dataNr[dataNr.length - 1]++
        }
        prev = this.programariDataInterval[i]
      }
      return [data, dataNr]
    },
    programariDataSortatSeven () {
      var data = []
      var dataNr = []
      var prev
      for (var i = 0; i < this.programariDataIntervalSeven.length; i++) {
        if (this.programariDataIntervalSeven[i] !== prev) {
          data.push(this.programariDataIntervalSeven[i])
          dataNr.push(1)
        } else {
          dataNr[dataNr.length - 1]++
        }
        prev = this.programariDataIntervalSeven[i]
      }
      return [data, dataNr]
    },
    programariData () {
      var data = []
      for (var i = 0; i < this.programariDataSortat[0].length; i++) {
        data.push({x: moment(this.programariDataSortat[0][i]).format('YYYY-MM-D'), y: this.programariDataSortat[1][i] - 1})
      }
      return data
    },
    programariDataSeven () {
      var data = []
      for (var i = 0; i < this.programariDataSortatSeven[0].length; i++) {
        data.push({x: moment(this.programariDataSortatSeven[0][i]).format('YYYY-MM-D'), y: this.programariDataSortatSeven[1][i] - 1})
      }
      return data
    }
  },
  mounted () {
    this.loadProgramari()
    setTimeout(() => {
      this.fillData()
    }, 1000)
  },

  methods: {
    ...mapActions('Programari', ['loadProgramari']),
    geta (chart) {
      this.options.scales.xAxes[0].time.min = new moment().add(-7, 'days')
      this.fillDataSeven()
    },
    getb () {
      this.options.scales.xAxes[0].time.min = new moment().add(-30, 'days')
      this.fillData()
    },
    fillData () {
      this.datacollection = {
        datasets: [{
          borderColor: '#4d85ff',
          borderWidth: 2,
          pointBackgroundColor: '#4d85ff',
          data: this.programariData,
          fill: false
        }]
      }
    },
    fillDataSeven () {
      this.datacollection = {
        datasets: [{
          borderColor: '#4d85ff',
          borderWidth: 2,
          pointBackgroundColor: '#4d85ff',
          data: this.programariDataSeven,
          fill: false
        }]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/block/ProgramariChart.vue